import mixpanel from 'mixpanel-browser';

const token = process.env.REACT_APP_MIXPANEL_TOKEN;
let initialized = false;

console.log('[ANALYTICS DEBUG] Module loaded. Token present:', !!token, 'Token value:', token);

export function initAnalytics() {
  console.log('[ANALYTICS DEBUG] initAnalytics called. initialized:', initialized, 'token:', !!token);
  if (initialized || !token) {
    console.log('[ANALYTICS DEBUG] Skipping init — already initialized or no token');
    return;
  }
  mixpanel.init(token, { track_pageview: false, persistence: 'localStorage' });
  initialized = true;
  console.log('[ANALYTICS DEBUG] Mixpanel initialized successfully');
}

export function identifyUser(userId) {
  if (!initialized) {
    console.log('[ANALYTICS DEBUG] identifyUser called but not initialized, skipping');
    return;
  }
  mixpanel.identify(userId);
  console.log('[ANALYTICS DEBUG] Identified user:', userId);
}

export function track(eventName, properties = {}) {
  console.log('[ANALYTICS DEBUG] track called:', eventName, properties, 'initialized:', initialized);
  if (!initialized) {
    console.log('[ANALYTICS DEBUG] Not initialized, event dropped');
    return;
  }
  mixpanel.track(eventName, properties);
  console.log('[ANALYTICS DEBUG] Event sent to Mixpanel:', eventName);
}